import { type FC, type ReactNode } from 'react';

import { Flex, Spacer, Text, type TextProps } from '@chakra-ui/react';

import { IconRightArrow } from '../Icons';

export type PopoverItemRowProps = {
  name: string;
  onRowClick: () => void;
  icon?: ReactNode;
  isDisabled?: boolean;
  marked?: boolean;
  showArrow?: boolean;
  textProps?: TextProps;
  isActive?: boolean;
};

export const PopoverItemRow: FC<PopoverItemRowProps> = ({
  name,
  onRowClick,
  icon,
  isDisabled,
  marked,
  showArrow = true,
  textProps = {},
  isActive = false,
}) => {
  return (
    <Flex
      align="center"
      px="12px"
      py="10px"
      onClick={() => !isDisabled && onRowClick()}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      pointerEvents={isDisabled ? 'none' : 'auto'}
      bg={isActive ? 'gray.50' : 'transparent'}
      _hover={{
        bg: 'gray.50',
      }}
      opacity={isDisabled ? 0.7 : 1}
      transition="0.2s"
      _first={{
        roundedTop: 'var(--chakra-radii-lg)',
      }}
      _last={{
        roundedBottom: 'var(--chakra-radii-lg)',
      }}
    >
      {icon}
      <Text color="gray.900" {...textProps}>
        {name}
      </Text>
      {marked && (
        <Text color="brand.500" fontWeight="medium" ml={1}>
          (1)
        </Text>
      )}
      <Spacer />
      {showArrow && <IconRightArrow fontSize="20px" />}
    </Flex>
  );
};
